"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SkipLink = void 0;
var react_1 = __importDefault(require("react"));
var component_library_1 = require("@kaizen/component-library");
var skip_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/skip.icon.svg"));
var SkipLink_module_scss_1 = __importDefault(require("./SkipLink.module.scss"));
/**
 * The skip link should be the first focusable element in the page.
 */
var SkipLink = function (_a) {
    var label = _a.label, skipTo = _a.skipTo;
    return (react_1["default"].createElement("a", { className: SkipLink_module_scss_1["default"].skipLinkContainer, href: "#".concat(skipTo) },
        react_1["default"].createElement("span", { className: SkipLink_module_scss_1["default"].skipLinkContent },
            react_1["default"].createElement("span", { className: SkipLink_module_scss_1["default"].skipLinkIcon },
                react_1["default"].createElement(component_library_1.Icon, { icon: skip_icon_svg_1["default"], role: "presentation" })),
            react_1["default"].createElement("span", null, label))));
};
exports.SkipLink = SkipLink;
exports.SkipLink.displayName = "SkipLink";
//# sourceMappingURL=SkipLink.js.map